<template>
  <div>
    <Card>
      <Select v-model="ClassificationID" value="ClassificationID" filterable clearable @on-change="PaperCoreSelectHandleClick" @on-clear="PaperCoreClearHandle" :label-in-value="true" style="width:15rem">
            <Option v-for="item in CategoryLists"
                    :value="item.ClassificationID"
                    :key="item.ClassificationID"
                    :label-in-value="true">{{ item.Classification }}</Option>
     </Select>
     <Button type="info" style="margin-left:5rem" @click="NewBuildHandleClick">新增</Button>

     <BillingTypeTable :BillingTypeTableList="BillingTypeTableList" @EditHandleClick="EditHandleClick" @DeleteHandleClick="DeleteHandleClick" style="margin-top:1rem"/>
    </Card>
    <Page :total="total" show-sizer show-elevator style="margin:1rem 0 8.3rem 0;text-align: center;" @on-change="PageChangeHandleClick" @on-page-size-change="PageSizeChangeHandleClick"/>

    <Drawer title="开票类型税点维护" width="80" :closable="false" v-model="isDrawer">
        <Form  :model="FormData" ref="formCustom" :rules="ruleCustom">
          <FormItem label="ID">
                <Input  v-model="FormData.TaxPointID" value="FormData.TaxPointID"  disabled/>
          </FormItem>
          <FormItem label="大类名称" prop="ClassificationID">
                <Select v-model="FormData.ClassificationID" value="FormData.ClassificationID" filterable clearable :label-in-value="true" >
                  <Option v-for="item in CategoryLists"
                          :value="item.ClassificationID"
                          :key="item.ClassificationID"
                          >{{ item.Classification }}</Option>
                </Select>
          </FormItem>
          <FormItem label="发票类型" prop="Attributes_value_ID">
                <Select v-model="FormData.Attributes_value_ID" value="FormData.Attributes_value_ID" filterable clearable :label-in-value="true" >
                  <Option v-for="item in BillingTypeList"
                          :value="item.Attributes_value_ID"
                          :key="item.Attributes_value_ID"
                          >{{ item.Name }}</Option>
                </Select>
          </FormItem>
          <FormItem label="税点" prop="TaxPoint">
                <Input type="number"  v-model="FormData.TaxPoint" value="FormData.TaxPoint"/>
          </FormItem>
        </Form>
        <div>
          <Button style="margin-right: 8px" @click="CancelHandleClick">取消</Button>
          <Button type="primary" @click="SubmitHandleClick('formCustom')">提交</Button>
        </div>
    </Drawer>
  </div>
</template>

<script>
import { MaterialCategory } from '../../../api/Materiel.js'
import { GetTaxPointListApi, GetBillingTypeListApi, ChangeBillingTypeData } from '../../../api/PriceRules.js'
import BillingTypeTable from './component/BillingTypeTable.vue'
export default {
  name: 'BillingType',
  components: {
    BillingTypeTable
  },
  data () {
    const validateClassificationID = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选大类'))
      }
      callback()
    }

    const validateAttributesvalueID = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请选发票类型'))
      }
      callback()
    }

    const validateTaxPoint = (rule, value, callback) => {
      if (value <= 0) {
        callback(new Error('请填写税点'))
      }
      callback()
    }
    return {
      CategoryLists: [],
      BillingTypeTableList: [],
      BillingTypeList: [],
      total: 0,
      CurrentPage: 1,
      pageSize: 10,
      ClassificationID: '',
      isDrawer: false,
      FormData: {
        TaxPointID: '',
        ClassificationID: '',
        Attributes_value_ID: '',
        TaxPoint: 0
      },
      State: 0,
      ruleCustom: {
        ClassificationID: [{ validator: validateClassificationID, trigger: 'blur' }],
        Attributes_value_ID: [{ validator: validateAttributesvalueID, trigger: 'blur' }],
        TaxPoint: [{ validator: validateTaxPoint, trigger: 'blur' }]
      }
    }
  },
  mounted: function () {
    this.GetCategoryLists()
    this.GetTaxPointList()
    this.GetBillingTypeList()
  },
  methods: {
    // 获取下拉列表数据
    GetBillingTypeList () {
      GetBillingTypeListApi().then(res => {
        if (res.IsSuccess) {
          this.BillingTypeList = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 获取下拉列表数据
    GetCategoryLists () {
      MaterialCategory().then(res => {
        if (res.IsSuccess) {
          this.CategoryLists = res.Data
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 获取数据表数据
    GetTaxPointList () {
      GetTaxPointListApi(this.ClassificationID, this.CurrentPage, this.pageSize).then(res => {
        if (res.IsSuccess) {
          this.total = res.Data.Table[0].total
          this.BillingTypeTableList = res.Data.Table1
        } else {
          this.$Message.error(res.Message)
        }
      })
    },
    // 切换页数
    PageChangeHandleClick (res) {
      if (this.CurrentPage !== res) {
        this.CurrentPage = res
        this.GetTaxPointList()
      }
    },
    // 每页数据量改变
    PageSizeChangeHandleClick (res) {
      if (this.pageSize !== res) {
        this.pageSize = res
        this.GetTaxPointList()
      }
    },
    // 头部下拉选项被选择后
    PaperCoreSelectHandleClick (value) {
      this.ClassificationID = value.value
      this.CurrentPage = 1
      this.GetTaxPointList()
    },
    // 头部下拉被清空后
    PaperCoreClearHandle () {
      this.ClassificationID = ''
      this.CurrentPage = 1
      this.GetTaxPointList()
    },
    // 点击新增按钮触发事件
    NewBuildHandleClick () {
      this.State = 0
      this.FormData = {
        TaxPointID: '',
        ClassificationID: '',
        Attributes_value_ID: '',
        TaxPoint: 0
      }
      this.isDrawer = true
    },
    // 点击编辑回调
    EditHandleClick (index) {
      this.State = 1
      this.FormData = {
        TaxPointID: this.BillingTypeTableList[index].TaxPointID,
        ClassificationID: this.BillingTypeTableList[index].ClassificationID,
        Attributes_value_ID: this.BillingTypeTableList[index].Attributes_value_ID,
        TaxPoint: this.BillingTypeTableList[index].TaxPoint
      }
      this.isDrawer = true
    },
    // 点击删除按钮回调
    DeleteHandleClick (index) {
      this.State = 2
      this.FormData = {
        TaxPointID: this.BillingTypeTableList[index].TaxPointID,
        ClassificationID: '',
        Attributes_value_ID: '',
        TaxPoint: 0
      }
      this.SubmissionData()
    },
    // 抽屉1取消回调
    CancelHandleClick () {
      this.isDrawer = false
      this.FormData = {
        Petid: '',
        id: '',
        PaperCore: '',
        SingleWeight: '',
        AuxiliaryQuantity: ''
      }
    },
    // 点击提交按钮回调
    SubmitHandleClick (name) {
      this.$refs[name].validate(valid => {
        if (valid) {
          this.SubmissionData()
        } else {
          this.$Message.error('Fail!')
        }
      })
    },
    // 提交数据规则变更数据
    SubmissionData () {
      ChangeBillingTypeData({
        TaxPointID: this.FormData.TaxPointID,
        ClassificationID: this.FormData.ClassificationID,
        Attributes_value_ID: this.FormData.Attributes_value_ID,
        TaxPoint: this.FormData.TaxPoint,
        operation: this.State
      }).then((res) => {
        if (res.IsSuccess) {
          this.$Message['success']({
            background: true,
            content: '提交成功'
          })
          this.isDrawer = false
          this.GetTaxPointList()
        } else {
          this.$Message.error(res.Message)
        }
      })
    }
  }
}
</script>
